import { useAutoSubmitResult } from "../hooks/useGetResult";

export const AutoSubmit = () => {
  useAutoSubmitResult();

  return null;
};
